export class FindingExclusionTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<FindingObjectType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<FindingObjectType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FindingExclusionTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
